import React from 'react';

export default function PageLoader({ message, inline = false }) {
  const label = message || 'Loading…';
  if (inline) {
    return (
      <div className="flex items-center justify-center py-8" role="status" aria-label={label}>
        <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-indigo-600" aria-hidden="true" />
        {message && <span className="ml-3 text-sm text-gray-500" aria-hidden="true">{message}</span>}
      </div>
    );
  }
  return (
    <div className="flex flex-col items-center justify-center min-h-[300px] gap-3" role="status" aria-label={label}>
      <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-indigo-600" aria-hidden="true" />
      {message && <p className="text-sm text-gray-500" aria-hidden="true">{message}</p>}
    </div>
  );
}
